import React from 'react'
import { string } from 'prop-types'
import { Button } from 'components/atoms'
import * as Styled from './QualityTransparency.styles'
import { TextContext } from 'hocs'

const QualityTransparency = ({ headline, copy, url = '' } = props) => {
  const textContext = React.useContext(TextContext)

  return (
    <Styled.QualityTransparency>
      <p>
        <b>{headline}</b>
      </p>
      <p className={ 'copy' }>{copy}</p>
      {url && url.length > 0 && (
        <Styled.DownloadButtonWrapper>
          <Button
            className='with-border'
            text={ textContext['qualityTransparency.button.label'] }
            onClick={ () => window.open(url) }
          />
        </Styled.DownloadButtonWrapper>
      )}
    </Styled.QualityTransparency>
  )
}

QualityTransparency.propTypes = {
  headline: string.isRequired,
  copy: string.isRequired,
  url: string.isRequired,
}

export default QualityTransparency
